import { CategoriasEstados } from "@cf-v5-workspace/enums";

export class ConfiguracionHistorialCambioEstadoModel {
    categoria: CategoriasEstados;
    idOrigen: number;
    idOrigenString?: string;
    tipoDocumento?: string;
    prefijoDocumento?: string;
}